import React, { Component } from 'react';
import { alertService } from '../../services/alert';
import config from '../../config';
import './index.css';

class AlertBar extends Component {
  updateInterval: null;

  state = {
    alerts: [],
    alertCycleIntervalIndex: 0,
    mounted: false,
    alertCycleInterval: null
  };

  componentDidMount() {
    this.updateAlerts();

    this.updateInterval = setInterval(this.updateAlerts.bind(this), config.refreshInterval);
  }

  componentWillUnmount() {
    this.clearAlertsIntervals();
  }

  clearAlertsIntervals() {
    this.state.alertCycleInterval && clearInterval(this.state.alertCycleInterval);
    this.updateInterval = null;

		this.setState({
	    alertCycleInterval: null
		});
  }

  updateAlerts() {
    alertService.getAlerts((alerts) => {
      if (this.state.alertCycleInterval) {
        clearInterval(this.state.alertCycleInterval);
      }

      alerts = alerts.filter(alert => {
        const now = new Date().getTime();
        const alertStartAt = new Date(alert.startAt).getTime();
        const alertEndAt = new Date(alert.endAt).getTime();

        return (alertStartAt < now) && (alertEndAt > now);
      });

      this.setState({
        alerts: alerts,
        alertCycleIntervalIndex: 0
      }, () => {
        this.setState({
          alertCycleInterval: setInterval(() => {
            let newIndex = this.state.alertCycleIntervalIndex + 1;

            if (newIndex >= this.state.alerts.length) {
              newIndex = 0;
            }

            this.setState({
              alertCycleIntervalIndex: newIndex
            });
          }, config.alertRefreshInterval)
        });
      });
    });
  }

  render() {
    const alert = this.state.alerts[this.state.alertCycleIntervalIndex];
    const content = alert ? alert.content : null;
    let link = null;
    let rendered = null;

    if (this.props.showLink) {
      link = (alert && alert.link) ? <a className="link" href={alert.link} target="_blank">. Afla mai multe detalii</a> : null;
    }

    if (alert) {
      rendered = (
        <div className="comp-alert-bar">
          <div className="col-md-12">
            <i className="icon fa fa-exclamation-triangle"></i>
            { content }{ link }
          </div>
        </div>
      );
    } else {
      rendered = null;
    }

    return rendered;
  }
}

AlertBar.defaultProps = {
	showLink: true
};

export default AlertBar;



// WEBPACK FOOTER //
// ./src/components/alertBar/index.js